import React, { useEffect, useState } from 'react';

const Sparkle = ({ children, onInteract }) => {
  const [sparkles, setSparkles] = useState([]);

  const createSparkle = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    
    const newSparkle = {
      id: Date.now() + Math.random(),
      x,
      y,
      size: Math.random() * 10 + 5,
      color: ['#FFD700', '#FFC0CB', '#FFB6C1', '#DDA0DD'][Math.floor(Math.random() * 4)]
    };
    
    setSparkles(prev => [...prev, newSparkle]);
    
    if (onInteract) onInteract();
    
    setTimeout(() => {
      setSparkles(prev => prev.filter(s => s.id !== newSparkle.id));
    }, 800);
  };

  return (
    <div className="relative inline-block" onClick={createSparkle}>
      {children}
      {sparkles.map(sparkle => (
        <div
          key={sparkle.id}
          className="absolute pointer-events-none animate-sparkle"
          style={{
            left: `${sparkle.x}px`,
            top: `${sparkle.y}px`,
            width: `${sparkle.size}px`,
            height: `${sparkle.size}px`,
            backgroundColor: sparkle.color,
            borderRadius: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      ))}
    </div>
  );
};

export default Sparkle;
